import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/tailwind.util';

/** 설정 화면의 가운데 정렬 컬럼(650px). 섹션 사이 간격(`gap-xs`)까지 여기서 소유한다. */
export const SettingColumn = ({
  children,
  className
}: PropsWithChildren<{
  className?: string;
}>) => {
  return <div className={cn('mx-auto flex max-w-[650px] flex-col gap-xs px-md mobile-lg:px-lg tablet-lg:px-0', className)} data-sentry-component="SettingColumn" data-sentry-source-file="SettingColumn.tsx">
      {children}
    </div>;
};